import { inject, Injectable } from '@angular/core';
import { PendoService } from '@callrail/looky/common/pendo/shared';
import { AppInitLayoutService } from '@callrail/looky/core';
import { isEmpty } from 'lodash-es';
import { Observable, map } from 'rxjs';
import { ColorsService } from '../colors/colors.service';
import { WhiteLabelAttributes } from '../colors/white-label-attributes';

@Injectable({
  providedIn: 'root',
})
export class AnubisInitService {
  private readonly pendo = inject(PendoService);

  constructor(
    private readonly colorsService: ColorsService,
    private readonly appLayout: AppInitLayoutService
  ) {}

  public init(): Observable<WhiteLabelAttributes> {
    return this.colorsService.colors().pipe(
      map((wlAttrs) => {
        const isWhiteLabel = !isEmpty(wlAttrs);
        this.appLayout.setup();
        this.appLayout.addFavicon();
        this.appLayout.addStyles('anubis', isWhiteLabel, wlAttrs);
        this.initializePendo(isWhiteLabel);
        return wlAttrs;
      })
    );
  }

  /**
   * There is no visitor or account to identify pre-login, so Pendo assigns an
   * anonymous visitor id. Because anubis is served from the same host as the
   * authenticated apps, the `identify()` those apps run after login stitches this
   * pre-login activity to the real visitor.
   */
  private initializePendo(isWhiteLabel: boolean): void {
    this.pendo.initializeAnonymous({
      visitor: { authenticated: false, whiteLabel: isWhiteLabel },
    });
  }
}
